import { render, staticRenderFns } from "./BusinessRepresentativesControl.vue?vue&type=template&id=03bbd4ae&"
import script from "./BusinessRepresentativesControl.vue?vue&type=script&lang=js&"
export * from "./BusinessRepresentativesControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports